// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"q9-z","disabled":"r9-z","label":"s9-z"};